import React from 'react';
import {
  Hero,
  AboutSection,
  ProjectsSection,
  AchievementsSection,
  NewsSection,
  SubscriptionSection
} from '../components';

const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <ProjectsSection />
      <AchievementsSection />
      <NewsSection />
      <SubscriptionSection />
    </>
  );
};

export default Home;
